import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { LandingPage } from './pages/LandingPage';
import './index.css';
// Google Analytics Measurement ID
const GA_MEASUREMENT_ID = 'G-75H8FC5Q21';
// Declare global types
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
// Initialize dataLayer
window.dataLayer = window.dataLayer || [];
// Define gtag function
function gtag(...args: any[]) {
  window.dataLayer.push(arguments);
}
// Make gtag available globally
window.gtag = gtag;
// Initialize Google Analytics
gtag('js', new Date());
gtag('config', GA_MEASUREMENT_ID, {
  page_path: window.location.pathname,
  send_page_view: true
});
// Load Google Analytics script
const script = document.createElement('script');
script.async = true;
script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
document.head.appendChild(script);
// Log for debugging (remove in production)
console.log('Google Analytics initialized with ID:', GA_MEASUREMENT_ID);
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-373">
    <LandingPage data-id="element-374" />
  </React.StrictMode>);